export var required = function (value) { return (!value ? 'Required' : undefined); };
export var maxLength100 = function (max, msgKey) { return function (value) {
    return value && value.length > max ? msgKey : undefined;
}; };
export var maxLength20 = function (max, msgKey) { return function (value) {
    return value && value.length > max ? msgKey : undefined;
}; };
// export const maxLength = (max: number) => (value: string | undefined) =>
//   value && value.length > max ? `Must be ${max} characters or less` : undefined;
export var minLength = function (min) { return function (value) {
    return value && value.length < min ? "Must be ".concat(min, " characters or more") : undefined;
}; };
export var number = function (value) {
    return value && Number.isNaN(Number(value)) ? 'CustDashboard.form.number' : undefined;
};
export var minValue = function (min) { return function (value) {
    return value && value < min ? "Must be at least ".concat(min) : undefined;
}; };
export var maxValue = function (max) { return function (value) {
    return value && value < max ? "Must be less than ".concat(max) : undefined;
}; };
export var email = function (value) {
    return value && !/^((?!\.)[\w\-_.+]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/i.test(value) ? 'Invalid email address' : undefined;
};
export var alphaNumeric = function (value) {
    return value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters' : undefined;
};
export var phoneNumber = function (value) {
    var trimmedValue = value ? value.replace(/\s+/g, '') : '';
    return trimmedValue && /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]{7,13}$/i.test(trimmedValue)
        ? 'CustDashboard.form.numberPhone' : undefined;
};
